// @ts-nocheck
import { fetchRechargeEventData, fetchRechargeRank, fetchRechargeList, fetchRechargeCollect, fetchRechargeHidden } from '@/services/activity';
import { Toast } from 'antd-mobile';
export default {
  namespace: 'rechargeEvent',
  state: {
    activityId: '',
    title: '',
    titleUrl: '',
    endTime: 0,
    rules: '',
    rechargeAmount: 0,
    rewardList: [],
    rankTotalList: [],
    meRechargeInfo: {},
    rankList: [],
    lastId: '',
  },
  reducers: {
    updateInit(state, { payload = {} }) {
      return {
        ...state,
        activityId: payload.activityId || '',
        title: payload.title || '',
        titleUrl: payload.titleUrl || '',
        endTime: payload.endTime || 0,
        rules: payload.rules || '',
        rewardList: payload.rewardList || [],
        rechargeAmount: payload.rechargeAmount || 0,
      };
    },
    updateRankTotal(state, { payload = [] }) {
      return {
        ...state,
        rankTotalList: payload || [],
      };
    },
    updateRankList(state, { payload = {} }) {
      let lastId = '';
      let newList = payload.force ? [] : [...state.rankList];
      if (payload && payload.rechargeList && payload.rechargeList.length) {
        lastId = payload.rechargeList[payload.rechargeList.length - 1].id;
        newList = [...newList, ...payload.rechargeList];
      }
      return {
        ...state,
        rankList: newList,
        meRechargeInfo: payload.meRechargeInfo || {},
        lastId,
      };
    },
    updateClearRankList(state, { payload = {} }) {
      return {
        ...state,
        rankList: [],
        meRechargeInfo: {},
        lastId: '',
      };
    },
  },
  effects: {
    *getData({ payload }, { call, put }) {
      const { error, data } = yield call(fetchRechargeEventData, payload);
      if (error || !data) {
        yield put({
          type: 'updateInit',
          payload: {},
        });
        Toast.show({
          content: error,
        });
        return false;
      }
      yield put({
        type: 'updateInit',
        payload: { ...data },
      });
      return { ...data };
    },
    *getRankTotal({ payload }, { call, put }) {
      const { error, data } = yield call(fetchRechargeRank, payload);
      if (error || !data) {
        yield put({
          type: 'updateRankTotal',
          payload: [],
        });
        Toast.show({
          content: error,
        });
        return false;
      }
      yield put({
        type: 'updateRankTotal',
        payload: data,
      });
      return true;
    },
    *getRankList({ payload }, { call, put, select }) {
      const { lastId } = yield select(state => state.rechargeEvent);
      const { error, data } = yield call(fetchRechargeList, {
        ...payload,
        lastId: payload.force ? '' : lastId,
      });
      if (error || !data) {
        yield put({
          type: 'updateRankList',
          payload: {},
        });
        Toast.show({
          content: error,
        });
        return false;
      }
      yield put({
        type: 'updateRankList',
        payload: { ...data, force: payload.force },
      });
      return true;
    },
    *clearRankList({ payload }, { call, put }) {
      yield put({
        type: 'updateClearRankList',
        payload: {},
      });
    },
    *getRewads({ payload }, { call }) {
      const { error, data } = yield call(fetchRechargeCollect, payload);
      if (error) {
        return {
          success: false,
          error,
        };
      }
      if (data) {
        return {
          data,
          success: true,
        };
      } else {
        return false;
      }
    },
    *hiddenSelfInfo({ payload }, { call }) {
      const { error, data } = yield call(fetchRechargeHidden, payload);
      if (error) {
        return {
          error,
          success: false,
        };
      }
      if (data) {
        return {
          success: true,
          data: { ...data },
        };
      } else {
        return false;
      }
    },
  },
};
